import React, { useState } from 'react';
import { CreditCard, FileText, CheckCircle2, DollarSign } from 'lucide-react';

export const NDISBillingModule: React.FC = () => {
  const [selectedSupportItem, setSelectedSupportItem] = useState('01_002_0107_1_1 - Personal Care Assistant ($193.99/hr)');
  const [claimStatusFilter, setClaimStatusFilter] = useState('ALL');
  const [generatedInvoice, setGeneratedInvoice] = useState('');

  const handleGenerateInvoice = () => {
    setGeneratedInvoice('Invoice #NDIS-2026-8801 generated & exported to CMS Portal!');
    setTimeout(() => setGeneratedInvoice(''), 4000);
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-emerald-100 text-emerald-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            NDIS & Clinical Insurance Billing
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">NDIS & Clinical Billing Protocol Engine</h2>
          <p className="text-xs text-slate-500">Automated NDIS price guide items, CPT code claiming, and invoice export</p>
        </div>

        <button 
          onClick={handleGenerateInvoice}
          className="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs rounded-xl shadow transition flex items-center gap-1.5"
        >
          <FileText className="w-4 h-4" />
          <span>Generate NDIS Claim Invoice</span>
        </button>
      </div>

      {generatedInvoice && (
        <div className="p-3 bg-emerald-50 border border-emerald-200 text-emerald-900 rounded-xl text-xs font-bold flex items-center gap-2">
          <CheckCircle2 className="w-4 h-4 text-emerald-600" />
          {generatedInvoice}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-3">
          <label className="block text-xs font-bold text-slate-700">Select NDIS Support Item Code</label>
          <select 
            value={selectedSupportItem}
            onChange={(e) => setSelectedSupportItem(e.target.value)}
            className="w-full px-3 py-2 border rounded-xl text-xs font-bold bg-white focus:ring-2 focus:ring-emerald-500"
          >
            <option value="01_002_0107_1_1 - Personal Care Assistant ($193.99/hr)">01_002_0107_1_1 - Personal Care Assistant ($193.99/hr)</option>
            <option value="15_048_0128_1_3 - Speech Pathology Individual ($193.99/hr)">15_048_0128_1_3 - Speech Pathology Individual ($193.99/hr)</option>
            <option value="15_056_0128_1_3 - Occupational Therapy Individual ($193.99/hr)">15_056_0128_1_3 - Occupational Therapy Individual ($193.99/hr)</option>
          </select>
        </div>

        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-3">
          <label className="block text-xs font-bold text-slate-700">Filter Claim Pipeline</label>
          <div className="flex gap-2">
            {['ALL', 'SUBMITTED', 'PAID', 'PENDING'].map(status => (
              <button
                key={status}
                onClick={() => setClaimStatusFilter(status)}
                className={`px-3 py-1.5 rounded-lg text-xs font-bold transition ${
                  claimStatusFilter === status ? 'bg-emerald-600 text-white shadow' : 'bg-white text-slate-700 border'
                }`}
              >
                {status}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
